import { atom } from 'jotai';
import { TeamType } from '@/types/filters';
import { Nullable } from '@/types/generic';

export const teamIdAtom = atom<Nullable<number>>(null);
export const teamTypeAtom = atom<Nullable<TeamType>>(null);

// unlike `teamIdAtom`, this atom globally tracks the last selected team id, outside the scope of any specific page/section.
export const globalTeamIdAtom = atom<Nullable<number>>(null);

// tracks whether the user has actively selected a team (via search or navigation)
export const hasUserSelectedTeamAtom = atom<boolean>(false);
